import ShareMsgBase from './A_G.ShareMsgBase';

class MsgRequestHelp extends ShareMsgBase {
  /**
   * The message that is sent when you request help through the Request Help feature or
   * Request Help bubble 2.0
   * @param {string} user1
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1, onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    this.bg = this._addExtImage(0, 0, 'img/Msg_Request_Help.png', 0, null, null);

    this.thanksforyourhelp = this.add(new G.Text(336, 50,
      OMT.language.getText('Thank you for helping me.'), {
        style: 'msg-white',
        fontSize: '40px',
      }, 0.5, 420));

    this.avatar1 = this._addExtImage(50, 139, user1, 0, 175, null);
  }
}

G.MsgRequestHelp = MsgRequestHelp;
